// @ts-ignore
import packageInfo from '../../package.json';
export const environment = {
  production: true,
  apiUrl: 'https://api-vendor.aclarian.com/api/',
  baseUrl: 'https://wccmud-vendor.aclarian.com',
  appName: 'West Cedar Creek Municipal Utility District  | VendorV2',
  tokenizationKey: 'PaQmTu-VE6uUF-9V6acY-jecjXr',
  datadogClientToken: 'pub09183ace909f9ea329e2e590bab145f5',
  datadogApplicationId: '8df014dc-d8ca-4874-a36e-31c20daa2830',
  datadogService: 'invoicing_wccm_prod',
  ApiKey: 'F#n8T!JOh%so9#Nr',
  env: 'PROD',
  version: packageInfo.version,
};
